module.exports = __webpack_public_path__ + "media/Video 131b.b3711ba6.mp4";